import React, { useState } from "react";
import { toastMessage } from "utils/toastMessage";
import { uploadAttachmentApi } from "services/support";
import useButtonLoader from "common/UseButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { FaTimes } from "react-icons/fa";

const FileUpload = ({ show, close, sendMessage = () => { } }) => {
    const [buttonLoaders, setButtonLoaders] = useButtonLoader("Send");
    const [files, setFiles] = useState([]);
    // console.log('file', files)
    //-------------Handle-multiple-image-selection-----------------
    const handleImageChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const validImages = selectedFiles.filter((file) =>
            file.type.startsWith("image/")
        );

        if (validImages.length !== selectedFiles.length) {
            toastMessage(
                "Some files were not images and were excluded.",
                "error",
                "uploadAttachment"
            );
        }

        if (validImages.length === 0) {
            return toastMessage(
                "Please upload valid image files (e.g., .jpg, .png, .gif).",
                "error",
                "uploadAttachment"
            );
        }

        setFiles((prev) => {
            const totalFiles = prev.length + validImages.length;
            if (totalFiles > 5) {
                toastMessage(
                    "You can only upload up to 5 images.",
                    "error",
                    "uploadAttachment"
                );
                return prev;
            }
            return [...prev, ...validImages];
        });
    };
    //------------remove-handle---------------
    const removeImage = (id) => {
        const updatedImage = files?.filter((_, _id) => _id !== id);
        setFiles(updatedImage);
    };

    //------------API-to-image--convert-to-url-----multiple-images-----------
    const uploadAttachment = async () => {
        if (files.length === 0) {
            return toastMessage(
                "Please upload at least one image.",
                "error",
                "selectMedia"
            );
        }
        try {
            setButtonLoaders(true);
            const formData = new FormData();
            files &&
                files?.forEach((file) => {
                    formData.append("media", file);
                });
            const res = await uploadAttachmentApi(formData);

            if (res?.data?.status === 200) {
                const media = res?.data?.data?.media || [];
                const uploadedImages = media.map((imageUrl) => imageUrl);

                if (uploadedImages.length > 0) {
                    sendMessage(uploadedImages);
                    modalClose();
                }
                
            } else {
                toastMessage(res?.data?.message, "error", "uploadError");
            }
        } catch (e) {
            console.error("Error during upload:", e);
            toastMessage("Error uploading images.", "error", "uploadError");
        } finally {
            setButtonLoaders(false);
        }
    };

    //--------modal-close-----------
    const modalClose = () => {
        close();
        setFiles([]);
    };
    return (
        <CustomModal
            show={show}
            handleClose={modalClose}
            className="input_image_model"
        >
            <div className="form_field">
                <label className="label">
                    Upload Image
                </label>
                <input
                    type="file"
                    id="image_file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                    className="input_select_img form-control"
                />
            </div>

            {/* {file.attachment?.name && <img src={URL.createObjectURL(file.attachment)} alt="" />} */}
            <div className="image-preview-container">
                {files && files?.map((file, index) => (
                    <div key={index} className="image-wrapper">
                        <img
                            src={URL.createObjectURL(file)}
                            alt="preview"
                            className="image-preview"
                        />
                        <button
                            type="button"
                            className="remove-button"
                            onClick={() => removeImage(index)}
                        >
                            <FaTimes />
                        </button>
                    </div>
                ))}
            </div>

            <div className="button_wrap">
                <button
                    type="button"
                    ref={buttonLoaders}
                    onClick={uploadAttachment}
                    className="button"
                >
                    Send
                </button>
            </div>
        </CustomModal>
    );
};

export default FileUpload;
